import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'
import type { TableCellProps } from 'components/shared/Table/types'

import { getLanguageSymbol } from 'utils/languages'

type LanguageCellProps = Pick<TableCellProps, 'hasIncreasedHeight'> & {
  language?: string
}

export const LanguageCell = ({
  language,
  hasIncreasedHeight,
}: LanguageCellProps) => (
  <Table.Cell type="body" {...{ hasIncreasedHeight }}>
    <Box align="center" justify="center" tagName="span">
      {getLanguageSymbol(language)}
    </Box>
  </Table.Cell>
)
